import type { FolderType } from '@newfront-insurance/files-api';

export enum ObjectReferenceType {
  ACCOUNT = 'account',
  BOR = 'bor',
  BOR_LETTER = 'bor-letter',
  CARRIER_QUOTE = 'carrier-quote',
  CLAIM = 'claim',
  MATTER = 'matter',
  CLIENT = 'client',
  POLICY = 'policy',
  POLICY_CHANGE = 'policy-change',
  POLICY_CHANGE_REQUEST = 'policy-change-request',
  POLICY_CHANGE_REQUEST_ITEM = 'policy-change-request-item',
  PROPOSAL = 'proposal',
  QUOTING = 'quoting-plan',
  SUBMISSION = 'submission',
  SUBMISSION_GROUP = 'submission-group',
  SUBMISSION_RESPONSE = 'submission-response',
  CONTRACT_REVIEW = 'contract-assessment-request',
  // account charges are represented by custom billable entities on payments BE
  ACCOUNT_CHARGE = 'custom-billable-entity',
  INVOICE = 'invoice',
  FOLDER = 'folder',
}

export enum EbObjectReferenceType {
  TOTAL_REWARDS_CARRIER = 'total-rewards-carrier',
  TIME_BUCKET_YEAR = 'time-bucket-year',
  TIME_BUCKET_MONTH = 'time-bucket-month',
}

export interface NewFolderData {
  parentFolderType: FolderType;
  folderName: string;
  associatedYears: string[];
}
